import Vue from 'vue'
import Router from 'vue-router'
import main from '../views/main'
import Home from '../views/home'
import about from '../views/about'
import service from '../views/service'
import brand from '../views/brand'
import dynamic from '../views/dynamic'
import recruit from '../views/recruit'
import contact from '../views/contact'
import assessment from '../views/service/assessment'
import company from '../views/about/company'
import culture from '../views/about/culture'
import team from '../views/about/team'
import silhouette from '../views/about/silhouette'
import business from '../views/service/business'
import civilization from '../views/service/civilization'
import evaluation from '../views/service/evaluation'
import market from '../views/service/market'
import detail from '../views/dynamic/detail/dynamic_detail'

Vue.use(Router)

const router = new Router({
  routes: [
    {path: '/', redirect: '/index'},
    {
      path: '/index',
      component: Home,
      meta:
        {
          title: '合肥安玛尔市场信息咨询有限公司',
          url: '/index',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/about',
      component: about,
      redirect: '/about/company',
      children: [
        {
          path: '/about/company',
          component: company,
          meta:
            {
              title: '公司简介-合肥安玛尔市场信息咨询有限公司',
              url: '/about',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/about/culture',
          component: culture,
          meta:
            {
              title: '企业文化-合肥安玛尔市场信息咨询有限公司',
              url: '/about',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/about/team',
          component: team,
          meta:
            {
              title: '团队管理-合肥安玛尔市场信息咨询有限公司',
              url: '/about',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/about/silhouette',
          component: silhouette,
          meta:
            {
              title: '公司剪影-合肥安玛尔市场信息咨询有限公司',
              url: '/about',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
      ],
      meta:
        {
          title: '关于我们-合肥安玛尔市场信息咨询有限公司',
          ac_url: 'about',
          url: '/about',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/service',
      component: service,
      redirect: '/service/assessment',
      children: [
        {
          path: '/service/assessment',
          component: assessment,
          meta:
            {
              title: '第三方评估-合肥安玛尔市场信息咨询有限公司',
              url: '/service',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/service/evaluation',
          component: evaluation,
          meta:
            {
              title: '服务质量测评-合肥安玛尔市场信息咨询有限公司',
              url: '/service',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/service/civilization',
          component: civilization,
          meta:
            {
              title: '文明眼管理平台-合肥安玛尔市场信息咨询有限公司',
              url: '/service',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/service/market',
          component: market,
          meta:
            {
              title: '市场调研-合肥安玛尔市场信息咨询有限公司',
              url: '/service',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
        {
          path: '/service/business',
          component: business,
          meta:
            {
              title: '商圈门店监测-合肥安玛尔市场信息咨询有限公司',
              url: '/service',
              content: {
                keywords: '第三方评估,市场调研,服务质量测评,文明眼',
                description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
              }
            }
        },
      ],
      meta:
        {
          title: '服务项目-合肥安玛尔市场信息咨询有限公司',
          url: '/service',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/brand',
      component: brand,
      meta:
        {
          title: '合作品牌-合肥安玛尔市场信息咨询有限公司',
          url: '/brand',
          ac_url: 'brand',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/dynamic',
      component: dynamic,
      meta:
        {
          title: '咨讯动态-合肥安玛尔市场信息咨询有限公司',
          url: '/dynamic',
          ac_url: 'dynamic',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/detail/dynamic_detail',
      component: detail,
      name: '新闻详情',
      meta:
        {
          title: '新闻详情-合肥安玛尔市场信息咨询有限公司',
          url: '/dynamic',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/contact',
      component: contact,
      meta:
        {
          title: '联系我们-合肥安玛尔市场信息咨询有限公司',
          url: '/contact',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
    {
      path: '/recruit',
      component: recruit,
      meta:
        {
          title: '招才纳贤-合肥安玛尔市场信息咨询有限公司',
          url: '/recruit',
          content: {
            keywords: '第三方评估,市场调研,服务质量测评,文明眼',
            description: '安玛尔公司为客户提供第三方评估、市场调研、服务质量测评服务，自主研发了“文明眼”全国文明城市动态管理平台。',
          }
        }
    },
  ],
  linkExactActiveClass: 'red',
})

router.beforeEach((to, from, next) => {
  if (to.meta.content) {

    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
    sessionStorage.setItem('activePath', to.meta.url)
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js